/* Refer to IANA Time Zone Database for more information. */
const TimeZones = {
    Eastern: "America/New_York",
    Central: "America/Chicago",
    Mountain: "America/Denver",
    Pacific: "America/Los_Angeles",
    Alaska: "America/Anchorage",
    Hawaii: "Pacific/Honolulu",
};

/* Module Exports */
module.exports = {
    appConfigKey: "AfbgDFMV5w3CQfrul1CMH4tLS0BYFqsl7FyjPEsB",
    appConfigProd:
        "https://uae4khqoag.execute-api.us-east-1.amazonaws.com/prod",
    appConfigDev: "https://os46zn9hmk.execute-api.us-east-1.amazonaws.com/dev",
    appDocket: "www.covetrusstockholderlitigation.com", // Must match CMS entry
    reCAPTCHAv3: "",
    appPayMethod: "", // Digital Disbursements
    cookieDuration: 30, // Days
    claimMethod: "claimsV4Post",
    languages: ["en"],
    appDomain: {
        options: {
            officialBanner: {
                display: true,
                pageLead: false, // If true, shows the CMS PageLead field above banner text
                content: {
                    en: "This is the official Settlement Website for the Covetrus Stockholder Litigation authorized by the Court of Chancery of the State of Delaware."
                }, // Per-language overrides: { en: "English text", es: "Spanish text" }
            },
            claimDeadlineTimezone: TimeZones.Pacific,
            courtDateTimezone: TimeZones.Eastern,
            contactPageEmailAdminButtonDisabled: true,
        },
    },
    sentry: {
        dsn: "",
        project: "",
    },
};
